import type { Shop } from "../engine/inventory/shop.js";

/**
 * I07b — session store for shops keyed by `shopkeeperId`.
 *
 * The Ink external `open_shop(npc_id)` emits `narrative:open_shop { npcId }`;
 * the shop UI looks the shop up here. A future content loader (I10)
 * populates this at map load; tests seed it directly.
 *
 * Kept tiny on purpose — the pure transactional helpers live in
 * `engine/inventory/shop.ts`; this file only owns session lookup and
 * replacement after a `buyItem` / `restockShop` call.
 */
const shops = new Map<string, Shop>();

export const ShopStore = {
  register(shop: Shop): void {
    shops.set(shop.shopkeeperId, shop);
  },

  get(shopkeeperId: string): Shop | undefined {
    return shops.get(shopkeeperId);
  },

  /** Replace an existing shop (after `buyItem` returns a new shop snapshot). */
  update(shop: Shop): void {
    shops.set(shop.shopkeeperId, shop);
  },

  all(): readonly Shop[] {
    return [...shops.values()];
  },

  /** Called on map teardown. Drops all shops. */
  clear(): void {
    shops.clear();
  },
};
